import { isEmpty, listFromCsv } from "./helpers";
import { Role } from "./types";

/**
 * Find the effective unit list.
 *
 * @param {Object[]} unitList - List of all own units
 * @param {String} userUnits - Units assigned to logged-in user e.g. unit1,unit2
 * @param {String} entityUnits - Units assigned to entity e.g. unit2,unit3
 * @param {String[]} roles - Roles of logged-in user
 * @returns
 */
const findUnits = (unitList, userUnits, entityUnits, roles = []) => {
  if (isEmpty(unitList) || !Array.isArray(unitList)) return [];
  const userUnitIds = roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? unitList.map(u => u.unitId) : listFromCsv(userUnits);
  const entityUnitIds = listFromCsv(entityUnits);
  return unitList.filter(u => entityUnitIds.includes(u.unitId) || userUnitIds.includes(u.unitId));
};

export default findUnits;
